import { Classes, Dialog } from "@blueprintjs/core";
import React from "react";
import styles from "./NewsDialog.module.scss";

/**
 * Окно с текстом новости — по кнопке «Подробнее» на плашке новости (NewsBanners)
 */
export const NewsDialog = ({ news, onClose }: NewsDialogProps) => (
    <Dialog
        title={news.name}
        icon="info-sign"
        canEscapeKeyClose={true}
        canOutsideClickClose={true}
        isOpen={true}
        onClose={onClose}
        style={{ width: "700px" }}
        backdropClassName="standard"
        className="figma-dialog"
    >
        <div className={`${Classes.DIALOG_BODY} ${styles.body}`}>
            <div className={styles.content} dangerouslySetInnerHTML={{ __html: news.text }} />
        </div>
    </Dialog>
);

interface NewsDialogProps {
    news: { name: string; text: string };
    onClose: () => void;
}
